import Vue from 'vue';
import Vuex from 'vuex';

// modules
import products from './modules/products.js';
import collections from './modules/collections.js';
import cart from './modules/cart.js';

Vue.use(Vuex);

const state = {};

export default new Vuex.Store({
  state,
  modules: {
    products,
    collections,
    cart,
  },
});
